const UserStatus = {
  PENDING_VERIFICATION: 'Pending Verification',
  ENABLED: 'Enabled',
  ACCOUNT_EXPIRED: 'Account Expired',
  LOCKED: 'Locked',
  PASSWORD_EXPIRED: 'Password Expired',
};

export default UserStatus;
